import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SelectivePreloadStrategy implements PreloadingStrategy {
  private criticalRoutes = ['auth-check', 'login', 'agent-dashboard'];
  
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.path && this.criticalRoutes.includes(route.path)) {
      return load();
    }
    
    if (route.data && route.data['preload']) {
      const delay = route.data['preloadDelay'] || 2000;
      return timer(delay).pipe(switchMap(() => load()));
    }
    
    return of(null);
  }
}

